@switch (componentModel.cardComponent.value){
    @case (CardTypes.member){
        <white-label-horizontal-carousel  [showCarets]="componentModel.carets.value"  [interval]="componentModel.duration.value * 1000">
            @for(item of componentModel.cards.value; track $index){
                <ng-template #item2>
                    <div [ngClass]="'w-w' + componentModel.width.value">
                        <white-label-team-card [componentModel]="item"></white-label-team-card>
                    </div>
                </ng-template>
        }
        </white-label-horizontal-carousel>
    }
    @case (CardTypes.blog){
        <white-label-horizontal-carousel [showCarets]="componentModel.carets.value"  [interval]="componentModel.duration.value * 1000">
            @for(item of componentModel.cards.value; track $index){
                    <ng-template #item3>
                        <div [ngClass]="'w-w' + componentModel.width.value">
                            <white-label-blog-card [componentModel]="item"></white-label-blog-card>
                        </div>
                    </ng-template>
            }
        </white-label-horizontal-carousel>
    }
    @case (CardTypes.media){
        <white-label-horizontal-carousel [showCarets]="componentModel.carets.value"  [interval]="componentModel.duration.value * 1000">
            @for(item of componentModel.cards.value; track $index){
                    <ng-template #item4>
                        <div [ngClass]="'w-w' + componentModel.width.value">
                            <white-label-media-card [componentModel]="item"></white-label-media-card>
                        </div>
                    </ng-template>
            }
        </white-label-horizontal-carousel>
    }
    @case (CardTypes.event){
        <white-label-horizontal-carousel [showCarets]="componentModel.carets.value"  [interval]="componentModel.duration.value * 1000">
            @for(item of componentModel.cards.value; track $index){
                    <ng-template #item5>
                        <div [ngClass]="'w-w' + componentModel.width.value">
                            <white-label-event-card [componentModel]="item"></white-label-event-card>
                        </div>
                    </ng-template>

            }
        </white-label-horizontal-carousel>
    }
    @case (CardTypes.feature){
        <white-label-horizontal-carousel [showCarets]="componentModel.carets.value"  [interval]="componentModel.duration.value * 1000">
            @for(item of componentModel.cards.value; track $index){
                    <ng-template #item2>
                        <div [ngClass]="'w-w' + componentModel.width.value">
                            <white-label-feature-card [componentModel]="item"></white-label-feature-card>
                        </div>
                    </ng-template>


            }
        </white-label-horizontal-carousel>
    }
    @default {
        <white-label-horizontal-carousel [showCarets]="componentModel.carets.value"  [interval]="componentModel.duration.value * 1000">
            @for(item of componentModel.cards.value; track $index){
                    <ng-template #item6>
                        <div [ngClass]="'w-w' + componentModel.width.value">
                            <white-label-default-card [componentModel]="item"></white-label-default-card>
                        </div>
                    </ng-template>
            }
        </white-label-horizontal-carousel>
    }
}
